import { create } from 'zustand';
import { api } from '../services/api';

export const useAnalyticsStore = create((set, get) => ({
  summary: null,
  charts: null,
  models: null,
  retention: null,
  hourlyActivity: null,
  activeUsers: null,
  activationFunnel: null,
  adMonetizationFunnel: null,
  providerStats: null,
  providerChartData: null,
  isLoading: false,
  error: null,

  // Загрузка сводки
  fetchSummary: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getAnalyticsSummary();
      set({ summary: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка данных для графиков
  fetchCharts: async (period = '7days') => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getAnalyticsCharts(period);
      set({ charts: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка статистики моделей
  fetchModelStats: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getModelStats();
      set({ models: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка retention данных
  fetchRetention: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getRetention();
      set({ retention: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка активности по часам
  fetchHourlyActivity: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getHourlyActivity();
      set({ hourlyActivity: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка самых активных пользователей
  fetchActiveUsers: async (period = '7days', limit = 20) => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getActiveUsers(period, limit);
      set({ activeUsers: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка воронки активации
  fetchActivationFunnel: async (period = '30days') => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getActivationFunnel(period);
      set({ activationFunnel: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка воронки монетизации рекламы
  fetchAdMonetizationFunnel: async (period = '30days') => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getAdMonetizationFunnel(period);
      set({ adMonetizationFunnel: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка статистики провайдеров
  fetchProviderStats: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getProviderStats();
      set({ providerStats: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка графика провайдеров
  fetchProviderChart: async (period = '7days') => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getProviderChart(period);
      set({ providerChartData: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Очистка
  clear: () => {
    set({ summary: null, charts: null, models: null, retention: null, hourlyActivity: null, activeUsers: null, activationFunnel: null, adMonetizationFunnel: null, providerStats: null, providerChartData: null, error: null });
  },

  // Сброс ошибки
  clearError: () => {
    set({ error: null });
  },
}));
